<script lang="ts">
	import { t } from 'svelte-i18n';
	import { getAccountStatus } from '@app/utils/user';
	import ButtonArrowPrimary from '$lib/elements/buttons/variants/ButtonArrowPrimary.svelte';
	import ButtonArrowWarning from '$lib/elements/buttons/variants/ButtonArrowWarning.svelte';
	import { page } from '$app/stores';
	import TagError from '$lib/elements/tags/variants/TagError.svelte';
	import TagSuccess from '$lib/elements/tags/variants/TagSuccess.svelte';
	import TagWarning from '$lib/elements/tags/variants/TagWarning.svelte';
	import TagNeutral from '$lib/elements/tags/variants/TagNeutral.svelte';
	import { isSidebarOpen } from '@app/stores/sidebar';
	import { AccountStateEnum } from '$lib/enums';

	$: userSatus = getAccountStatus($page?.data?.user, $t);
</script>

<div class="flex flex-col gap-2">
	{#if userSatus.state === AccountStateEnum.CHECKED}
		<TagSuccess props={{ label: userSatus.ctaLabel, iconLeft: 'check', classNames: 'w-full' }} />
	{/if}
	{#if userSatus.state === AccountStateEnum.PENDING}
		<TagNeutral props={{ label: userSatus.ctaLabel, iconLeft: 'clock', classNames: 'w-full' }} />
	{/if}
	{#if userSatus.state === AccountStateEnum.WARNING}
		<TagWarning props={{ classNames: 'w-full' }}>
			<ButtonArrowWarning
				props={{
					label: userSatus.ctaLabel,
					href: userSatus.ctaLink
				}}
				on:click={() => ($isSidebarOpen = false)}
			/>
		</TagWarning>
	{/if}
	{#if userSatus.state === AccountStateEnum.ERROR}
		<TagError props={{ classNames: 'w-full' }}>
			<ButtonArrowPrimary
				props={{ label: userSatus.ctaLabel, href: userSatus.ctaLink }}
				on:click={() => ($isSidebarOpen = false)}
			/>
		</TagError>
	{/if}
</div>
